export default function SectionAbout() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-50">关于我们</h2>
          <p className="mt-6 text-sm md:text-base text-foreground-400 leading-relaxed">
            91精品影视是一个专注提供<strong className="text-foreground-200 font-semibold">高清免费在线看片</strong>服务的影视平台。
            自上线以来，我们始终秉持"免费、高清、流畅"的服务理念，致力于为广大影迷打造极致的观影体验。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed">
            站内汇聚了超过三万部<strong className="text-foreground-200 font-semibold">电影、电视剧、动漫和综艺</strong>资源，
            覆盖国内外各类热门题材。通过先进的CDN加速与智能缓冲技术，实现<strong className="text-foreground-200 font-semibold">91影视高清免费不缓冲</strong>的流畅播放。
            无论您身在何处，只需打开浏览器即可畅享<strong className="text-foreground-200 font-semibold">91影视在线看片</strong>的便捷体验。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-400 leading-relaxed">
            我们拥有一支专业的资源运营团队，每日持续更新最新热播内容，确保平台的时效性和资源丰富度。
            91精品影视坚持<strong className="text-foreground-200 font-semibold">完全免费、无需注册</strong>的运营模式，
            通过优质的用户体验赢得信赖。未来我们将持续优化服务，为更多影迷提供更好的91精品影视免费观看体验。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 md:gap-6">
            {[
              { icon: 'ri-team-line', text: '专业运营团队' },
              { icon: 'ri-timer-line', text: '每日持续更新' },
              { icon: 'ri-shield-star-line', text: '安全可靠稳定' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-100 border border-background-300/30">
                <i className={`${item.icon} text-primary-400 text-sm`}></i>
                <span className="text-xs text-foreground-300 whitespace-nowrap">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}